import { useContext, useState } from "react";
import { LicenseHeaderBriefInfo } from "../../../../../generated/data-contracts";
import { IAxiosError, LicenseesUtils } from "../../../../../utils";
import { AvisSection } from "../../../../shared/components/form";
import { AvisContext } from "../../../../shared/context/AvisContext";
import { ErrorLoadingDataHoc } from "../../../../shared/error/ErrorLoadingDataHoc";
import { ActualReportsForLicenseGrid } from "../../../licenseReports/components/ReportGrids/ActualReportsForLicenseGrid";

interface ILicenseReportsProps {
  licenseBriefInfo: LicenseHeaderBriefInfo | undefined;
}
export function LicenseReports(props: Readonly<ILicenseReportsProps>) {
  const { licenseBriefInfo } = props;
  const { res } = useContext(AvisContext);
  const [error, setError] = useState<IAxiosError>();
  const urlParams = LicenseesUtils.getUrlParams();
  if (!urlParams.licenseId) return;

  return (
    <ErrorLoadingDataHoc error={error}>
      <AvisSection
        title={res("licensees_LicenseReports_label_SectionActive")}
        textToDisplayKey="portal_LIC_LicenseReports"
        subTitleComponent={
          <div className="pb-3">
            {licenseBriefInfo?.licenseSettingsInfo?.description}
          </div>
        }
      >
        <ActualReportsForLicenseGrid
          licenseId={urlParams.licenseId}
          archive={false}
          setError={setError}
        />
      </AvisSection>
      <AvisSection
        title={res("licensees_LicenseReports_label_SectionArchive")}
        textToDisplayKey="portal_LIC_LicenseReports_1"
      >
        <ActualReportsForLicenseGrid
          licenseId={urlParams.licenseId}
          archive={true}
          setError={setError}
        />
      </AvisSection>
    </ErrorLoadingDataHoc>
  );
}
